import type { Components } from '@mui/material/styles';

import SvgIcon from './SvgIcon';

export default function MuiSvgIcon(): Components['MuiSvgIcon'] {
  return {
    defaultProps: {
      fontSize: 'inherit',
      component: SvgIcon,
    },
    styleOverrides: {
      fontSizeX5Small: {
        fontSize: 8,
      },
      fontSizeX4Small: {
        fontSize: 10,
      },
      fontSizeX3Small: {
        fontSize: 12,
      },
      fontSizeX2Small: {
        fontSize: 14,
      },
      fontSizeXSmall: {
        fontSize: 16,
      },
      fontSizeSmall: {
        fontSize: 18,
      },
      fontSizeMedium: {
        fontSize: 20,
      },
      fontSizeLarge: {
        fontSize: 24,
      },
      fontSizeXLarge: {
        fontSize: 28,
      },
      fontSizeX2Large: {
        fontSize: 32,
      },
      fontSizeX3Large: {
        fontSize: 36,
      },
      fontSizeX4Large: {
        fontSize: 40,
      },
      fontSizeX5Large: {
        fontSize: 44,
      },
      fontSizeX6Large: {
        fontSize: 48,
      },
      fontSizeX7Large: {
        fontSize: 52,
      },
      fontSizeX8Large: {
        fontSize: 56,
      },
      fontSizeX9Large: {
        fontSize: 60,
      },
    },
  };
}
